import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { Trans, useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { useState } from "react";

import { colors } from "src/assets/styles/settings";
import Button from "src/components-v2/Button";
import Icon from "src/components-v2/Icon";
import privateRoutes from "src/routes/private-routes";
import ReKYBModal from "./ReKYBModal";

function ReKYBBanner({ formBusiness, ownerEmail }) {
  const { pathname } = useLocation();
  const { t } = useTranslation(["home"]);
  const [showModal, setShowModal] = useState(false);

  if (pathname !== privateRoutes.home.path) return null;

  return (
    <>
      <div className="u-bg-golden-yellow u-px-4 u-py-2 md:u-px-8 2xl:u-px-12 u-flex u-gap-4">
        <div>
          <Icon size="1x" color={colors.golden_yellow_3} icon={faInfoCircle} />
        </div>
        <div className="u-text-dark-golden-yellow">
          <div className="u-mb-0 u-font-bold">{t("re-kyb.banner.title")}</div>
          <div className="u-mb-0 u-text-semi">
            <Trans t={t} i18nKey={"re-kyb.banner.content"}>
              <span className="u-font-bold" />
              <Button
                variant="tertiary"
                className="u-h-auto u-p-0 u-align-baseline"
                onClick={() => setShowModal(!showModal)}
              />
            </Trans>
          </div>
        </div>
      </div>

      <ReKYBModal
        formBusiness={formBusiness}
        ownerEmail={ownerEmail}
        onClose={() => setShowModal(false)}
        show={showModal}
      />
    </>
  );
}

export default ReKYBBanner;
